module.exports = __webpack_public_path__ + "static/media/view and serach items.63a0eaaa.svg";